/* const java = require('@/assets/imgs/java_256.png')
const spring = require('@/assets/imgs/spring_256.png')
const maven = require('@/assets/imgs/maven_256.png')
const mongo = require('@/assets/imgs/mongo2_256.png')
const solr = require('@/assets/imgs/solr_256.png')
const html5 = require('@/assets/imgs/html5_256.png')
const css3 = require('@/assets/imgs/css3_256.png')
const js = require('@/assets/imgs/js_256.png')
const vuejs = require('@/assets/imgs/vuejs_256.png')
const fr = require('@/assets/imgs/fr_256.png')
const en = require('@/assets/imgs/en_256.png')

const sfr = require('@/assets/imgs/logo_sfr.png')
const orange = require('@/assets/imgs/logo_orange.png')
const alstom = require('@/assets/imgs/logo_alstom.png')
const accenture = require('@/assets/imgs/logo_accenture.png')
const ustl = require('@/assets/imgs/logo_ustl2.png') */

const data = {
  profile: {
    firstName: 'Laurent',
    lastName: 'DECHOUX',
    title: 'Architecte Logiciel',
    experience: '12 ans d\'expérience',
    pdf: 'static/docs/CV_Laurent_Dechoux.pdf'
  },
  sections: [
    {
      id: 'me',
      label: 'Présentation',
      type: 'PROFILE',
      text: '<p>Suite à l’obtention d’un master en informatique, j’ai débuté ma carrière en 2006 en intégrant la société Unilog (devenue Logica puis CGI). J’ai pu y faire mes premières armes et développer mes compétences, principalement dans le secteur télécom et plus précisément sur les aspects e-commerce. J’ai par la suite intégré la société SFR et participé activement à la mise en place de sa stratégie omnicanale. Début 2018 j\'ai intégré le groupe TF1 et pris part à un ambitieux projet de refonte des applications MYTF1.' +
      '<p>Polyvalent, mon parcours m’a amené à travailler sur des problématiques touchant à la fois les systèmes backend et frontend. Rigoureux et pragmatique, j’ai pendant 12 ans toujours fait preuve d’une grande autonomie. Simplicité, fiabilité et performance sont les trois maître-mots qui guident mes choix dans les solutions que je conçois.</p>' +
      '<p>En dehors de mes activités professionnelles, mes centres d’intérêt sont divers. La photographie, la littérature SF, le cinéma, les sciences et l’humour rythment mon quotidien.</p>',
      contact: {
        text: 'Contact :',
        values: [
          {
            picto: '<i class="fa fa-linkedin-square" aria-hidden="false"></i>',
            url: 'https://www.linkedin.com/in/laurent-dechoux-7b0b02146'
          },
          {
            picto: '<i class="fa fa-envelope" aria-hidden="false"></i>',
            mail: 'contact@laurent-dechoux.fr'
          }
        ]
      }
    },
    {
      id: 'exp',
      label: 'Expériences',
      type: 'EXPERIENCE',
      missions: [
        {
          logo: 'tf1',
          title: 'Lead Developer Middleware',
          from: 'Depuis Janvier 2018',
          to: '',
          text: 'Au sein de la direction technique et dans le cadre de la refonte des applications MYTF1 pour les box opérateurs :',
          tasks: [
            'Conception, développement et mise en service du nouveau middleware MYTF1 (GraphQL)',
            'Animation de l\'équipe de développement (3 à 4 développeurs)',
            'Bench bout en bout de la solution mise en place'
          ],
          badges: [
            'Golang', 'GraphQL', 'Jenkins', 'Elasticsearch', 'GRPC', 'Rest', 'RabbitMQ', 'Docker', 'Kubernetes', 'devops'
          ]
        },
        {
          logo: 'sfr',
          title: 'Architecte Logiciel',
          from: 'Octobre 2012',
          to: 'Décembre 2017',
          text: 'Dans le cadre du projet FUSE ayant pour objectif la création d\'une chaine de vente omnicanale (distribution, service client, télévente et sfr.fr) :',
          tasks: [
            'Conception, développement et maintenance de l\'architecture micro-services dédiée à la prise de commande',
            'Refonte bout en bout (de la phase d\'étude à la mise en production) du catalogue des offres mobiles',
            'Internalisation puis refonte de l\'outil de vente utilisé en distribution, service client et télévente',
            'Prise en charge des problèmatiques liées à l\'omnicanalité (validation des paniers cross-canaux de vente)',
            'Conception et développement de la solution de vente en mobilité (outil tablette) pour le réseau de distribution SFR',
            'Support niveau 3 (semaine et week-end)'
          ],
          badges: [
            'Java', 'Tomcat', 'Spring', 'Maven', 'Solr', 'MongoDB', 'Rest', 'HornetQ', 'Angular', 'Vue.js', 'devops'
          ]
        },
        {
          logo: 'accenture',
          title: 'Consultant Technique',
          from: 'Juillet 2012',
          to: 'Aout 2012',
          text: 'Dans le cadre du transfert de connaissances relatif au forfait de maintenance applicative SFR ADM BA06, en particulier sur l’outil de vente en distribution V&S (Vente & Souscription) :',
          tasks: [
            'Formation des équipes (France et Inde)',
            'Assistance à la mise en place des plateformes de recette et développement',
            'Accompagnement sur site des équipes'
          ]
        },
        {
          logo: 'sfr',
          title: 'Référent Technique',
          from: 'Octobre 2009',
          to: 'Juin 2012',
          text: 'Dans le cadre du forfait de maintenance applicative SFR ADM BA06, en particulier sur l’outil de vente en distribution V&S (Vente & Souscription) :',
          tasks: [
            'Assurer la cohérence technique transverse entre les différents projets du forfait',
            'Conception, chiffrage et suivi des chantiers techniques',
            'Gestion et suivi des incidents de production',
            'Formation des intervenants techniques (équipes partagées entre la France et l’Inde)',
            'Rédaction et validation des documents techniques SFR',
            'Support niveau 3 (semaine et week-end)'
          ],
          badges: [
            'Java', 'Spring', 'Websphere', 'Oracle', 'MQSeries', 'Soap'
          ]
        },
        {
          logo: 'sfr',
          title: 'Expert Technique',
          from: 'Octobre 2008',
          to: 'Septembre 2009',
          text: 'Dans le cadre de la TMA V&S (outil de vente en distribution), au sein d’une cellule technique dédiée de 8 personnes :',
          tasks: [
            'Réalisation de sujets technique',
            'Analyse et correction des incidents de production',
            'Rédaction des documents techniques SFR',
            'Rédaction et validation des spécifications techniques',
            'Mise en production',
            'Support niveau 3 (semaine et week-end)'
          ],
          badges: [
            'Java', 'Spring', 'Websphere', 'Oracle', 'MQSeries', 'Soap'
          ]
        },
        {
          logo: 'sfr',
          title: 'Analyste Technique et Fonctionnel',
          from: 'Avril 2008',
          to: 'Septembre 2008',
          text: 'Au sein de l’équipe IBEB, tests d’intégration bout en bout des applications V&S (outil de vente en distribution), ORIAN (SI mobile SFR) et SIGC (référentiel client) :',
          tasks: [
            'Rédaction et exécution des cahiers de recette',
            'Analyse et correction des anomalies (périmètre V&S)',
            'Support fonctionnel et technique aux membres de l’équipe de test',
            'Installation des plateformes de test'
          ],
          badges: [
            'Java', 'Struts', 'C', 'Oracle', 'MQSeries', 'Soap'
          ]
        },
        {
          logo: 'sfr',
          title: 'Développeur Java',
          from: 'Septembre 2007',
          to: 'Mars 2008',
          text: 'Au sein de l’équipe en charge de la TMA V&S, j\'ai eu en charge l\'intégration des services SIGC (référentiel client) au frontal de vente utilisé en distribution :',
          tasks: [
            'Conception, chiffrage et développement',
            'Rédaction et exécutions des tests unitaires',
            'Correction des anomalies',
            'Rédaction des spécifications techniques'
          ],
          badges: [
            'Java', 'Struts', 'C', 'Oracle', 'MQSeries', 'Soap'
          ]
        },
        {
          logo: 'orange',
          title: 'Développeur Java',
          from: 'Avril 2007',
          to: 'Septembre 2007',
          text: 'Dans le cadre du projet WSS (portail Web B2B dédié à la gestion des flottes de mobiles) :',
          tasks: [
            'Conception et développement',
            'Chiffrage des demandes d’évolution',
            'Rédaction et exécution des tests unitaires',
            'Suivi des incidents (réunion hebdomadaire avec le client)'
          ],
          badges: [
            'Java', 'Ant', 'Jonas', 'ATG', 'Oracle'
          ]
        },
        {
          logo: 'alstom',
          title: 'Ingénieur Support N2',
          from: 'Octobre 2006',
          to: 'Mars 2007',
          text: 'Au sein de l’équipe niveau 2 en charge de l’outil de gestion de contenu Pollen (CMS des différents sites institutionnels Alstom Transports et Energie) :',
          tasks: [
            'Formation des utilisateurs',
            'Assistance aux utilisateurs',
            'Qualification des anomalies avant transfert au support niveau 3',
            'Suivi et planification du déploiement des correctifs en production'
          ]
        }
      ]
    },
    {
      id: 'skills',
      label: 'Compétences',
      type: 'SKILLS',
      text: 'Fort de mes 12 années d’expérience, j’ai pu travailler dans des environnements techniques différents et ainsi développer mes compétences, principalement dans la conception de backend Java. J’ai également renforcé mes connaissances générales en développement Web (HTML5, CSS3, ECS6) et me suis plus particulièrement intéressé au framework Vue.js. ' +
      'Plus récement j\'ai eu la chance de travailler à la mise en oeuvre d\'un nouveau socle technique chez TF1 autour de technologies modernes comme Golang, GraphQL et GRPC. ' +
      'Enfin, mes différentes missions m’ont régulièrement amené à partager mes acquis à travers la formation des équipes (en français mais également en anglais pour les intervenants indiens).',
      back: ['golang', 'java', 'spring', 'maven', 'mongo', 'graphql', 'grpc', 'elasticsearch', 'solr', 'docker', 'kubernetes'],
      front: ['html5', 'css3', 'js', 'vuejs'],
      langs: ['fr', 'en']
    },
    {
      id: 'edu',
      label: 'Formations',
      type: 'EDUCATIONS',
      educations: [
        {
          year: '2005',
          title: 'Master TIIR - Université Lille1',
          text: 'Master Informatique – Technologie de l’Informatique et des Réseaux',
          logo: 'ustl'
        },
        {
          year: '2004',
          title: 'IUP GMI - Université Lille1',
          text: 'Institut Universitaire Professionnalisé – Génie Mathématique et Informatique',
          logo: 'ustl'
        }
      ]
    }
  ],
  links: [
    {
      picto: '<i class="fa fa-linkedin-square fa-2x" aria-hidden="false"></i>',
      url: 'https://www.linkedin.com/in/laurent-dechoux-7b0b02146/'
    },
    {
      picto: '<i class="fa fa-flickr fa-2x" aria-hidden="false"></i>',
      url: 'https://www.flickr.com/photos/iota_fr/'
    },
    {
      picto: '<i class="fa fa-twitter-square fa-2x" aria-hidden="false"></i>',
      url: 'https://twitter.com/iotafr'
    },
    {
      picto: '<i class="fa fa-envelope fa-2x" aria-hidden="false"></i>',
      mail: 'contact@laurent-dechoux.fr'
    }
  ]
}

export default data



// WEBPACK FOOTER //
// ./src/content.js